import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  RegisteredNode,
  RegisteredNodeMenuActionsType,
} from 'data/registeredNode/registeredNode.types';
import './registered-node-action-menu.scss';

type Props = {
  selectedItem?: RegisteredNode;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const RegisteredNodeMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="RegisteredNodeMenu" className="registered-node-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="registered-node-action-menu-button"
        data-testid={`${RegisteredNodeMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {/* {hasPrivilegeToDelete && (
      <Button
        className="registered-node-action-menu-button"
        data-testid={`${RegisteredNodeMenuActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )} */}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('registeredNode.delete.success')}
        displayMessage={
          t('collectionFunction.deletePopup.message', { name: selectedItem.nodeName })
        }
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default RegisteredNodeMenu;
